import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useBuildRequest } from "./use_handle_file";
import { useValidation } from "./use_validation";
import { saveUser } from "../context/userReducer";
import { useDispatch } from 'react-redux';
import { updateFileDetail } from "../context/fileDetailsReducer";

export const useSendFile = () => {
    const error = useSelector(state => state.error);
    const file = useSelector(state => state.file);
    const user = useSelector((state) => state.user);
    const navigate = useNavigate();
    const { calcIfSumAllMatching } = useValidation();
    const { handleErrors, buildRequest } = useBuildRequest();
    const dispatch = useDispatch();

    const sendFile = () => {
        if (error !== null) {
            alert("בעמודות המסומנות באדום ישנה שגיאה, ולכן הרשומה לא תיקלט. \nיש לתקן את השגיאות בקובץ,\n לא ניתן לשלוח את הקובץ לעדכון במערכת עד שכל השורות תיהנה תקינות. ")
            return;
        }
        if (calcIfSumAllMatching(file, user)) {
            alert("הסכום הכולל גבוה מהסכום הזמין להכנסה \n לא ניתן לשלוח את הקובץ עד לתיקון הסכום ")
            return;
        }
        if (file.length === 0) {
            alert("קובץ ריק")
            return;
        }

        dispatch(updateFileDetail({ load: true }))
        fetch("https://parasha.iyun.co.il/api/partnership/saveFile/" + user.representativeCode + "/" + user.partenshipCode, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(buildRequest()),
        })
            .then((res) => res.json())
            .then((data) => {
                dispatch(updateFileDetail({ load: false }))
                const updatedUser = { ...user, enteredAmount: data.enteredSum };
                saveUser(updatedUser)
                handleErrors(data)
                navigate("/fileResults");
            })
            .catch((e) => {
                dispatch(updateFileDetail({ load: false }))
                alert(" שגיאה בשליחת הקובץ. אנא נסה שוב.");
            })
    }


    return { sendFile };
}
